import { useQuery } from '@tanstack/react-query'
import { cpGetLineNotificationActivity } from '@/lib/api/controlPlaneClient'
import { useAuthStore } from '@/lib/store/authStore'

export function useLineNotificationActivity(options?: { enabled?: boolean }) {
  const activeStorefrontKey = useAuthStore((s) => s.activeStorefrontKey)
  return useQuery({
    queryKey: ['line-notification-activity', activeStorefrontKey],
    queryFn: cpGetLineNotificationActivity,
    staleTime: 60 * 1000,
    enabled: options?.enabled !== false,
  })
}
